import { ScmInstance } from "@/instance/axios";
import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from "@lukemorales/query-key-factory";
import {
  ScmApiPurchaseOrderCategoriesGetRequest,
  ScmApiPurchaseOrderCategoriesPostRequest,
  ScmApiPurchaseOrderCategoriesPurchaseOrderCategoryIdDeleteRequest,
  ScmApiPurchaseOrderCategoriesPurchaseOrderCategoryIdPutRequest,
} from "@sizlcorp/sizl-api-document/dist/models";

export const purchaseOrderCategories = createQueryKeys("purchaseOrderCategories", {
  all: null,
  get: (params: ScmApiPurchaseOrderCategoriesGetRequest) => {
    // const queryParams = { ...params };
    const queryParams = {
      ...params,
      query: JSON.stringify({ $and: params?.query }),
      sort: params.sort?.length ? params.sort : "-id",
    }; // 수발주 유형 조회 시 기본 정렬 표시

    return {
      queryKey: [queryParams, JSON.stringify(queryParams)],
      queryFn: () => ScmInstance.purchaseOrderCategoriesGet(queryParams),
    };
  },
});

export const mutatePurchaseOrderCategories = createMutationKeys("purchaseOrderCategories", {
  create: (params: ScmApiPurchaseOrderCategoriesPostRequest) => ({
    mutationKey: [params.purchaseOrderCategoriesGetRequest],
    mutationFn: () => ScmInstance.purchaseOrderCategoriesPost(params),
  }),
  update: (params: ScmApiPurchaseOrderCategoriesPurchaseOrderCategoryIdPutRequest) => ({
    mutationKey: [
      params.purchaseOrderCategoriesGetRequest,
      params.purchaseOrderCategoriesGetRequest,
    ],
    mutationFn: () => ScmInstance.purchaseOrderCategoriesPurchaseOrderCategoryIdPut(params),
  }),
  delete: (params: ScmApiPurchaseOrderCategoriesPurchaseOrderCategoryIdDeleteRequest) => ({
    mutationKey: [params.purchaseOrderCategoryId],
    mutationFn: () => ScmInstance.purchaseOrderCategoriesPurchaseOrderCategoryIdDelete(params),
  }),
});

export const purchaseOrderCategoriesQueryKeys = mergeQueryKeys(
  purchaseOrderCategories,
  mutatePurchaseOrderCategories,
);
